<style rel="stylesheet/scss" lang="scss">
  .lang-setting {
    width: 100%;
    text-align: left;
    tr {
      display: flex;
      height: 35px;
      line-height: 35px;
      th:not(.key), td:not(.key) {
        flex-grow: 1;
        padding-right: 8px;
      }
    }
  }
</style>
<template>
  <Modal
    v-model="visible"
    :loading="true"
    :mask-closable="false"
    :title="$t('z.dlg.internetLangSetting')"
    :width="80"
    @on-ok="saveLangTxts"
    @on-cancel="close" style="max-height: 95%">
    <Collapse v-model="curPanel">
      <Panel name="cur" v-if="currentLangs">
        {{$t('z.dlg.panel_cur')}}
        <table class="lang-setting" slot="content">
          <tr>
            <th width="140" class="key">key</th>
            <th v-for="lang in langs">{{$t('z.'+lang.code)}}</th>
          </tr>
          <tr v-for="(item,index) in currentLangs" :key="index">
            <td class="key" width="140">{{item.key}}</td>
            <td v-for="lang in langs"><Input v-model="item[lang.lang]" :placeholder="lang.lang=='zh-CN'?item.tipTxt:null"></Input></td>
          </tr>
        </table>
      </Panel>
      <Panel name="global" v-if="globalLangs">
        {{$t('z.dlg.panel_global')}}
        <table class="lang-setting" style="max-height: 800px" slot="content">
          <tr>
            <th width="140" class="key">key</th>
            <th v-for="lang in langs">{{$t('z.'+lang.code)}}</th>
          </tr>
          <tr v-for="(item,index) in globalLangs" :key="index">
            <td class="key" width="140">{{item.key}}</td>
            <td v-for="lang in langs"><Input v-model="item[lang.lang]" :placeholder="lang.lang=='zh-CN'?item.tipTxt:null"></Input></td>
          </tr>
        </table>
      </Panel>
    </Collapse>
  </Modal>
</template>

<script>
// import {globalTxts, pageTxts} from '../lang-page'
import _lang from '../../data/lang.js'

export default {
  name: 'lang-setting',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      curPanel: [],
      loadedGlobal: false,
      loadedCurPage: false,
      pageKey: null,
      globalLangs: [],
      currentLangs: [],
      oldGlobalLangs: [], // 未修改前全局国际化数据
      oldCurrentLangs: []// 未修改前当前页面国际化数据
    }
  },
  mounted () {
    if (this.curPageLang) {
      this.curPanel.push('cur')
    } else {
      this.curPanel.push('global')
    }
  },
  methods: {
    saveLangTxts () {
      var updateData = this.getUpdateData()
      if (updateData.length == 0) {
        this.close()
        this.$Message.warning(this.$t('z.tip.noupdate'))
      } else {
        _lang.saveLangTxts(updateData).then(res => {
          if (res.data.code == 0) {
            this.clearCache()
            this.$Modal.confirm({
              title: this.$t('z.tip.tip'),
              content: this.$t('z.tip.save_success') + this.$t('z.tip.refresh_see'),
              okText: this.$t('z.btn.refresh'),
              cancelText: this.$t('z.btn.notnow'),
              onOk: () => {
                window.location.reload()
              },
              onCancel: () => {
                this.close()
              }
            })
          } else {
            this.close()
            this.$Message.error(this.$t('z.tip.error_request'))
          }
        }).catch(res => {
          console.error(res)
          this.close()
          this.$Message.error(this.$t('z.tip.error_request'))
        })
      }
    },
    // 清楚缓存
    clearCache () {
      this.langs.forEach(l => {
        $tool.ss.removeItem(l.lang)
      })
    },
    close () {
      this.visible = false
      this.$emit('input', false)
    },
    loadData () {
      this.loadCurPageLang()
      this.loadGlobal()
    },
    loadCurPageLang () {
      var pageKey = this.$route.name
      if (!pageKey || !this.pageTxts[pageKey]) {
        this.loadedCurPage = false
        this.currentLangs = null
        return
      }

      if (this.loadedCurPage && (this.pageKey && pageKey != this.pageKey)) {
        return
      }
      this.pageKey = pageKey
      _lang.loadCurPageLang(pageKey).then(res => {
        if (res.data.code == 0) {
          this.setCurPageLang(res.data.data)
          this.loadedCurPage = true
        } else {
          this.setCurPageLang([])
          this.$Message.error('当前页面国际化数据加载失败')
        }
      })
    },
    loadGlobal () {
      if (this.loadedGlobal) {
        return
      }
      _lang.loadGlobalLang().then(res => {
        if (res.data.code == 0) {
          this.setGlobalLang(res.data.data)
          this.loadedGlobal = true
        } else {
          this.setGlobalLang([])
          this.$Message.error('全局国际化数据加载失败')
        }
      })
    },
    setCurPageLang (data) {
      var pageKey = this.$route.name
      var map = {}
      data.forEach(d => {
        var obj = map[d.msgColumn]
        if (!obj) {
          obj = map[d.msgColumn] = {}
        }
        obj[d.lang] = d.text
      })

      var currentLangs = []
      this.pageTxts[pageKey].forEach(g => {
        var langTxt = this.getLangTxt(g, map[g.key])
        currentLangs.push(langTxt)
      })
      this.oldCurrentLangs = JSON.parse(JSON.stringify(currentLangs))
      this.currentLangs = currentLangs
    },
    setGlobalLang (data) {
      var map = {}
      data.forEach(d => {
        var obj = map[d.msgKey]
        if (!obj) {
          obj = map[d.msgKey] = {}
        }
        obj[d.lang] = d.text
      })

      var globalLangs = []
      this.globalTxts.forEach(g => {
        var langTxt = this.getLangTxt(g, map[g.key])
        globalLangs.push(langTxt)
      })
      this.oldGlobalLangs = JSON.parse(JSON.stringify(globalLangs))
      this.globalLangs = globalLangs
    },
    getLangTxt (global, data = {}) {
      var obj = {key: global.key}
      this.langs.forEach(l => {
        obj[l.lang] = data[l.lang]
      })
      obj.tipTxt = global.txt
      return obj
    },
    // 获取已修改的数据
    getUpdateData () {
      var data = []
      if (this.loadedGlobal) {
        this.globalLangs.forEach((g, i) => {
          var old = this.oldGlobalLangs[i]
          this.langs.forEach(l => {
            if (g[l.lang] != old[l.lang]) {
              data.push({
                lang: l.lang,
                msgKey: g.key,
                text: g[l.lang]
              })
            }
          })
        })
      }
      if (this.loadedCurPage) {
        var pageKey = this.$route.name
        this.currentLangs.forEach((d, i) => {
          var old = this.oldCurrentLangs[i]
          this.langs.forEach(l => {
            if (d[l.lang] != old[l.lang]) {
              data.push({
                lang: l.lang,
                msgKey: pageKey,
                msgColumn: d.key,
                text: d[l.lang]
              })
            }
          })
        })
      }
      return data
    }
  },
  computed: {
    curPageLang () {
      var name = this.$route.name
      if (name && this.pageTxts[name]) {
        return this.pageTxts[name]
      }
      return null
    },
    langs () {
      return this.$store.state.langs
    },
    globalTxts () {
      return this.$store.state.globalTxts
    },
    pageTxts () {
      return this.$store.state.pageTxts
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.loadData()
      }
      this.visible = val
    }
    /* currentLangs: {
        handler(newValue, oldValue) {
          console.log(newValue,oldValue)
          if (oldValue) {
            for (let i = 0; i < newValue.length; i++) {
              if (oldValue[i] != newValue[i]) {
                console.log(newValue)
              }
            }
          }
        },
        deep: true
      } */
  }
}
</script>
